export const MOVER_TAREA_EVENT = 'profase:tarea-movida';

const ESTADO_API: Record<string, string> = {
  pendiente: 'PENDIENTE',
  enproceso: 'EN_PROCESO',
  bloqueado: 'BLOQUEADO',
  noautorizado: 'NO_AUTORIZADO',
  pendientedeautorizacion: 'PENDIENTE_DE_AUTORIZACION',
  finalizado: 'FINALIZADO',
};

const ESTADO_CHAT: Record<string, string> = {
  PENDIENTE: 'Pendiente',
  EN_PROCESO: 'En Proceso',
  BLOQUEADO: 'Bloqueado',
  NO_AUTORIZADO: 'No Autorizado',
  PENDIENTE_DE_AUTORIZACION: 'Pendiente de Autorización',
  FINALIZADO: 'Finalizado',
};

function foldEstado(value: string): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[\s_-]+/g, '');
}

export function toApiEstado(nombre: unknown): string {
  const raw = String(nombre ?? '').trim();
  return ESTADO_API[foldEstado(raw)] ?? raw.toUpperCase().replace(/[\s-]+/g, '_');
}

export function movedTaskChatMessage(
  id: string,
  descripcion: string,
  estadoA: unknown,
): string {
  const label = ESTADO_CHAT[toApiEstado(estadoA)] ?? String(estadoA ?? '').trim();
  return `Se movió la tarea ${id} ${descripcion} a ${label}, que hago para trabajar en esta tarea ?`;
}

export function revealMovedEstado(
  searchParams: URLSearchParams,
  estadoA: unknown,
  chatMessage?: string,
): URLSearchParams {
  const params = new URLSearchParams(searchParams);
  const dest = toApiEstado(estadoA);
  if (!dest) return params;
  params.set('vista', 'kanban');
  const selected = params.getAll('estado');
  if (selected.length > 0 && !selected.includes(dest)) {
    params.append('estado', dest);
  }
  if (chatMessage?.trim()) {
    params.set('chat-msg-to', chatMessage.trim());
  }
  return params;
}

export function applyMovedEstadoToHash(estadoA: unknown, chatMessage?: string): void {
  if (typeof window === 'undefined') return;
  const hash = window.location.hash || '';
  const q = hash.indexOf('?');
  const path = (q >= 0 ? hash.slice(0, q) : hash) || '#/mis-tareas';
  const current = new URLSearchParams(q >= 0 ? hash.slice(q + 1) : '');
  const next = revealMovedEstado(current, estadoA, chatMessage);
  const nextHash = `${path}?${next.toString()}`;
  if (nextHash !== hash) {
    window.location.hash = nextHash;
  }
}

function authHeader(): Record<string, string> {
  const token = localStorage.getItem('jhi-authenticationToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

function findFirstTask(estadoDe: string): { id: string; descripcion: string } | null {
  const folded = foldEstado(estadoDe);
  if (!folded || typeof document === 'undefined') return null;
  const columns = Array.from(
    document.querySelectorAll<HTMLElement>('[data-kanban-column], [data-kanban-title]'),
  );
  const column = columns.find(el => (
    foldEstado(el.getAttribute('data-kanban-column') ?? '') === folded
    || foldEstado(el.getAttribute('data-kanban-title') ?? '') === folded
  ));
  const card = column?.querySelector<HTMLElement>('[data-kanban-task-id]')
    ?? Array.from(document.querySelectorAll<HTMLElement>('[data-kanban-task-id]')).find(
      el => foldEstado(el.getAttribute('data-kanban-task-estado') ?? '') === folded,
    )
    ?? null;
  const id = card?.getAttribute('data-kanban-task-id')?.trim() ?? '';
  if (!id) return null;
  return { id, descripcion: card?.getAttribute('data-kanban-task-descripcion') ?? '' };
}

export async function moverTarea(estadoDe: unknown, estadoA: unknown): Promise<void> {
  const de = String(estadoDe ?? '').trim();
  const a = String(estadoA ?? '').trim();
  if (!de || !a) return;
  const task = findFirstTask(de);
  if (!task) return;
  const res = await fetch(`/api/usuario/me/actividad/${task.id}/mover`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify({ estado: toApiEstado(a) }),
  });
  if (!res.ok) return;
  applyMovedEstadoToHash(a, movedTaskChatMessage(task.id, task.descripcion, a));
  window.dispatchEvent(new CustomEvent(MOVER_TAREA_EVENT, {
    detail: { id: task.id, estadoDe: de, estadoA: a },
  }));
}

if (typeof window !== 'undefined') {
  window.moverTarea = moverTarea;
}
